import { fetchInstance } from '../utils/fetchInstance.ts';

export interface InventoryItem {
  itemId: number;
  itemType: 'pokemon_ball' | 'pokemon' | 'evolution_stone' | 'ticket' | string;
  quantity: number;
  name: string;
  icon: string;
}

export interface InventoryResponse {
  data: InventoryItem[];
  total: number;
  offset: number;
  limit: number;
}

export const getInventory = async (params?: {
  offset?: number;
  limit?: number;
}): Promise<InventoryResponse> => {
  return fetchInstance.get<InventoryResponse>('users/inventory', { params });
};

export interface User {
  userId: string;
  username: string;
  password: string | null;
  discordId: string;
  avatarUrl: string;
  legendaryMeme: number;
  dudMeme: number;
  createdAt: Date;
  updatedAt: Date;
  memeLastVote: Date;
}

export interface UpdateMePayload {
  username?: string;
  avatarUrl?: string | null;
  currentPassword?: string;
  newPassword?: string;
}

export const updateMe = async (payload: UpdateMePayload): Promise<User> => {
  return fetchInstance.patch<User>('users/me', payload);
};

export const getMeUser = async () => {
  return await fetchInstance.get<User>('users/me');
};

/**
 * Vérifie l'authentification sans déclencher de redirect 401.
 * Retourne null si non connecté ou en cas d'erreur.
 */
// ─── Leaderboard Prestige ─────────────────────────────────────────────────────

export interface PrestigeLeaderboardEntry {
  rank: number;
  username: string;
  score: number;
  expeditionScore: number;
  pokedexEntries: number;
  pokemon75Plus: number;
  highIvPokemon: number;
  happyPokemon: number;
}

export const getPrestigeLeaderboard = (): Promise<PrestigeLeaderboardEntry[]> =>
  fetchInstance.get<PrestigeLeaderboardEntry[]>('users/leaderboard/prestige');

export const tryGetMeUser = async (): Promise<User | null> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    const res = await fetch(`${apiUrl}/api/users/me`, {
      credentials: 'include',
    });
    if (!res.ok) return null;
    return res.json() as Promise<User>;
  } catch {
    return null;
  }
};
